import script from "./LoyaltyInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./LoyaltyInfo.vue?vue&type=script&setup=true&lang=js"

import "./LoyaltyInfo.vue?vue&type=style&index=0&id=10106204&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10106204"]])

export default __exports__